import axios from "@/api/config_php";

export const feedbackInsert = param => axios.post(`/amp/api/v1/feedback/store`, param);

export const feedbackList = param => axios.get(`/amp/api/v1/feedback/lists`, { params: param });

export const feedbackDetail = param => axios.get(`/amp/api/v1/feedback/detail`, { params: param });

export const feedbackDetailReply = param => axios.get(`/amp/api/v1/feedback/detailReply`, { params: param });

export const feedbackDel = param => axios.post(`/amp/api/v1/feedback/del`, param);
